import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import SubNavigation from '../../containers/sub-navigation';
import EstimationHistory from '../../containers/estimation-history';

const SubNavigationBlock = props => <SubNavigation {...props} />;
SubNavigationBlock.displayName = 'SubNavigation';

export default withDynamicComponents({
  componentWhitelist: [
    EstimationHistory,
  ],
  mapInputToOutput: [
    ['estimationHistory', 'estimationHistory'],
  ],
})(SubNavigationBlock);



// WEBPACK FOOTER //
// ./src/blocks/sub-navigation/index.jsx